import { useTranslation } from "react-i18next";
import {
  IReceiptTripItinerary,
  Receipt,
} from "../../../models/receipt/receipt";
import { getMainTitle } from "../../web-receipt/handler/receiptStatus.helper";
import { getPoiTimeInfo } from "../../web-receipt/handler/receiptPOI.helper";

export const useReceiptCardInfo = (data: Receipt) => {
  const { i18n, t } = useTranslation("paymentPage");
  const lang = i18n.language === "zh" ? "zhHK" : "en";
  const total = data?.total || 0;
  const dashFee = data?.dashFee || 0;
  const tripFare = data?.amount || 0;
  const hotelPhone = data?.supportContactPhoneNumber || data?.organization?.settings?.webHailingPage?.supportContactPhoneNumber || "";
  const status = data?.status || "PENDING_PAYMENT";
  const pickup = data?.tripItinerary?.[0] as IReceiptTripItinerary;
  const dropoff = data?.tripItinerary?.[1] as IReceiptTripItinerary;
  const pickupDisplayName =
    pickup?.i18n?.[lang]?.displayName || pickup?.i18n?.zhHK?.displayName || "";
  const pickupAddress =
    pickup?.i18n?.[lang]?.formattedAddress ||
    pickup?.i18n?.zhHK?.formattedAddress ||
    "";
  const dropoffDisplayName =
    dropoff?.i18n?.[lang]?.displayName ||
    dropoff?.i18n?.zhHK?.displayName ||
    "";
  const dropoffAddress =
    dropoff?.i18n?.[lang]?.formattedAddress ||
    dropoff?.i18n?.zhHK?.formattedAddress ||
    "";
  const mainTitle = getMainTitle(
    t,
    "scheduled",
    data?.time,
    dropoffDisplayName,
    data?.eta,
  );

  const pickupTime = getPoiTimeInfo(data?.time);
  const updatedAtPOI = getPoiTimeInfo(data?.updatedAt);
  const clientType = data?.clientType || "";
  const isShowSupportContact = data?.organization?.settings?.webHailingPage?.isShowSupportContact || false;
  const type = data?.type || "";

  const licensePlate = data.driver?.licensePlate || "";
  const carModel = data.driver?.vehicleModel || data.driver?.vehicle?.model || "";
  const carMake = data.driver?.vehicleMake || data.driver?.vehicle?.make || "";
  const driverName =
    data.driver?.driverName ||
    (lang === "zhHK"
      ? data.driver?.nameZh || data.driver?.name || ""
      : data.driver?.name || data.driver?.nameZh || "");

  const driverPhone = data.driver?.driverId || data.driver?.phoneNumber || "";
  const carImageUrl = data.driver?.vehicle?.iconUrl || "";

  return {
    dashFee,
    tripFare,
    total,
    hotelPhone,
    status,
    mainTitle,
    pickupDisplayName,
    pickupAddress,
    dropoffDisplayName,
    dropoffAddress,
    pickupTime,
    updatedAtPOI,
    clientType,
    isShowSupportContact,
    type,
    licensePlate,
    carModel,
    carMake,
    driverName,
    driverPhone,
    carImageUrl
  };
};
